import React, { useEffect, useState } from "react";
import DashboardCard from "../../Components/Card/DashboardCard";
import { useSelector } from "react-redux";
import { Box, Stack, Grid } from "@mui/material";
import configServ from "../../services/config";
// icons
import PeopleIcon from "@mui/icons-material/People";
import AutoStoriesIcon from "@mui/icons-material/AutoStories";
import OfflinePinIcon from "@mui/icons-material/OfflinePin";
import { useNavigate } from "react-router-dom";
import CircularProgress from "@mui/material/CircularProgress";

function Dashboard() {
  //#region code
  const { user_id, company_id, is_super } = useSelector(
    (state) => state.GlobalVariables
  );
  const navigate = useNavigate();
  const open = useSelector((state) => state.sideExpand.open);

  const [count, setCount] = useState({});
  const [loading, setLoading] = useState(false);
  const fetchDashboardCount = async () => {
    try {
      const userId = user_id;
      if (userId === null) {
        navigate("/");
        return;
      }
      setLoading(true);
      const res = await configServ.getDashboardCount({
        user_id: user_id,
        company_id: company_id,
        is_super: is_super,
      });
      if (res.status === 200) {
        setCount(res);
      }
    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDashboardCount();
  }, [company_id]);

 const cardData = [
  {
    title: "UPCOMING EXAMS",
    number: loading ? (
      <CircularProgress size={20} sx={{ color: "#fb6340" }} />
    ) : (
      count.upcomingExams
    ),
    icon: <AutoStoriesIcon sx={{ color: "#fb6340" }} />,
    link: "/master-entry/item",
  },
  {
    title: "STUDENTS REGISTERED",
    number: loading ? (
      <CircularProgress size={20} sx={{ color: "#fb6340" }} />
    ) : (
      count.registeredCandidates
    ),
    icon: <PeopleIcon sx={{ color: "#fb6340" }} />,
    link: "/student-registration",
  },
  {
    title: "EXAMS DONE",
    number: loading ? (
      <CircularProgress size={20} sx={{ color: "#fb6340" }} />
    ) : (
      count.examsDone
    ),
    icon: <OfflinePinIcon sx={{ color: "#fb6340" }} />,
    link: "/exam-report",
  },
  {
    title: "Active Batch",
    number: loading ? (
      <CircularProgress size={20} sx={{ color: "#fb6340" }} />
    ) : (
      count.activeBatchCount
    ),
    icon: <OfflinePinIcon sx={{ color: "#fb6340" }} />,
    link: "/master-entry/batch",
  },
];

  //#endregion

  return (
    <>
      <Box
        sx={{
          backgroundColor: "#6270e4",
          width: "100%",
          // height:'200vh'
          px: 2, // ← left-right padding
        }}
      >
        <Grid container spacing={3} px={2} py={5}>
          {cardData.map((item, index) => (
            <Grid
              item
              xs={12} // Mobile → 1 per row
              sm={6} // Small screen → 2 per row
              md={4} // Medium screen → 3 per row
              lg={3} // Large screen → 4 per row
              key={index}
            >
             <DashboardCard data={item} navigate={navigate} />

            </Grid>
          ))}
        </Grid>
      </Box>
    </>
  );
}

export default Dashboard;
